import React from 'react';
import { useTranslation } from 'react-i18next';
import Alert from '@material-ui/lab/Alert';

import styles from './GenericErrorMessage.module.scss';

export default function GenericErrorMessage(): JSX.Element {
  const { t } = useTranslation(['checkout']);

  return (
    <Alert severity={'error'} className={styles.errorMessage}>
      {t('SHIPPING_GENERIC_ERROR_MESSAGE')}
    </Alert>
  );
}
